require('raphael');
require('treant-js');
require('chart.js');
require('chartjs-plugin-zoom');
require('jquery-countdown');



// WEBPACK FOOTER //
// ./resources/js/app/bootstrap.js